import { AliAppletPartnerCode } from 'src/utils/staticData';
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
// 接口请求封装
// import { dmEnv } from '@dm/utils';
import promise from 'es6-promise';
import isomorphicFetch from 'isomorphic-fetch';
import throttle from 'lodash.throttle';
import { StaticLoading, StaticToast } from 'src/components/common';
import cookies from './cookie';
import { Serialize } from './serialization';
import storage from './storage';
import validate from './validate';

promise.polyfill();
declare const window: any;

interface Options {
  url: string;
  type: string;
  data?: object | String;
  action?: any;
  isloading?: boolean;
  headers?: object;
  error?: any;
  success?: any;
  [propName: string]: any;
  needLogin?: boolean;
  needLoading?: boolean;
  redirectMode?: 'replace' | 'push';
  noRelogin?: boolean;
}

export interface BaseResponse<T> {
  // @deprecated
  code: number | string;
  status: number;
  errorCode: string;
  errorMsg: string;
  result: T;
  success: boolean;
}

export interface BaseResponsePage<T> {
  content: T[];
  resultList?: T[];
  empty: boolean;
  first: boolean;
  hasContent: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: { sort: []; pageNumber: 0; pageSize: 10; offset: 0; unpaged: false; paged: true };
  size: number;
  totalElements: number;
  totalPages: number;
}

export const fetch = (options: Options) => {
  const { url = '', type, data, search, isloading = false, needLoading = false } = options;
  (isloading || needLoading) && StaticLoading.show();
  // const { url = '', type, data } = options;
  const token = storage.get('token');
  const channelPoint = cookies.get('channelPoint');
  const opts: any = {
    credentials: 'include',
    url,
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      channelPoint,
      ...options.headers,
    },
  };
  if (type.toUpperCase() === 'GET'
    || type.toUpperCase() === 'PUT'
    || type.toUpperCase() === 'DELETE') {
    opts.method = type.toUpperCase();
    if (typeof data === 'string') {
      opts.url = `${url}?${data}`;
    } else if (typeof data === 'object') {
      opts.url = `${url}?${Serialize(data)}`;
    }
  }
  if (type.toUpperCase() === 'POST') {
    opts.method = 'POST';
    opts.body = JSON.stringify(data || {});
    opts.headers = {
      ...opts.headers,
      'Content-Type': 'application/json; charset=UTF-8',
    };
    if (typeof search === 'string') {
      opts.url = `${url}?${encodeURIComponent(search)}`;
    } else if (typeof search === 'object') {
      opts.url = `${url}?${Serialize(search)}`;
    }
  }
  if (type.toUpperCase() === 'UPLOAD') {
    opts.method = 'POST';
    opts.body = data;
  }

  return isomorphicFetch(opts.url, opts)
    .then((req) => toJson(req, options))
    .then((res) => resHandler(res, options));
};

function toJson(resp: any, options: any) {
  // console.log('toJson resp', resp);
  return resp.json().then((json) => ({ ...json, status: resp.status }));
}

export async function fetchJson<T = any>(options: Options): Promise<BaseResponse<T>> {
  return fetch(options);
}

// 请求成功处理
function resHandler(res: any, options: any) {
  const { isloading = true, needLoading = true } = options;
  (isloading || needLoading) && StaticLoading.hide();

  // 401 Unauthorized
  if (res.status && res.status === 401) {
    // noRelogin=true 处理优惠券推广链接401拉起页面半弹窗登陆
    const { noRelogin } = options;
    if (noRelogin) {
      options.success && options.success(res);
      return Promise.resolve(res);
    }
    StaticToast.error(res.errorMsg || '请重新登录');
    return gotoLogin(res, options);
  }

  if (res.status && res.status !== 200) {
    return errorHandler(res, options);
  }
  if (!res.success) {
    const { needToast = true } = options;
    needToast && StaticToast.error(res.errorMsg || '服务异常');
  }

  options.success && options.success(res);
  return Promise.resolve(res);
}

// 异常处理
function errorHandler(res, options) {
  const { needToast = true } = options;
  if (res.errorMsg) {
    needToast && StaticToast.error(res.errorMsg || '服务异常');
  }

  return Promise.reject(res);
}

// 避免一个页面多个请求401,出现 redirectToURL 覆盖问题
const jumpLogin = throttle((redirectToURL, redirectMode) => {
  console.info('jumpLogin: ', redirectToURL, redirectMode);

  // 在自有支付宝小程序里
  if (validate.isAlipayApplet() && storage.get('aliAppletPartnerCode') === AliAppletPartnerCode.ZA_FSJK) {
    window.reactHistory.go(-1);
    let miniProgramRedirectTo = `${encodeURIComponent('/pages/webview/index?url=')}${redirectToURL}`;
    // 避免在新的 webview 打开我的页面，底部无 tabbar
    if (window.reactHistory.location.pathname === '/my') {
      miniProgramRedirectTo = '';
    }

    my && my.navigateTo({
      url: `/pages/login/index?redirectTo=${miniProgramRedirectTo}`,
    });
    return;
  }

  // 在自有微信小程序里
  if (validate.isFromOwnMiniApplet()) {
    window.reactHistory.go(-1);
    let miniProgramRedirectTo = `${encodeURIComponent('/pages/webview/index?url=')}${redirectToURL}`;
    // 避免在新的 webview 打开我的页面，底部无 tabbar
    if (window.reactHistory.location.pathname === '/my') {
      miniProgramRedirectTo = '';
    }
    wx.miniProgram.navigateTo({
      url: `/pages/login/index?redirectTo=${miniProgramRedirectTo}`,
    });
  } else {
    window.reactHistory?.[redirectMode]({
      pathname: '/login',
      search: `redirectTo=${redirectToURL}`,
    });
  }
}, 1000, { trailing: false });

// 跳转登录
function gotoLogin(res, options: Options) {
  const { redirectMode = 'replace' } = options;
  const { pathname, search } = window.location;
  const redirectToURL = encodeURIComponent(pathname + search);
  jumpLogin(redirectToURL, redirectMode);
  return Promise.resolve(res || {});
}
